import * as React from "react";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import { ICalendarEvent } from "../../../../../../../../../motw_core/Calendar/ICalendarEvent";
import { SaveCalendarEditorStateAndCloseAsync } from "./SaveCalendarEditorStateAndCloseAsync";
import { ICalendarEventEditorState } from "./ICalendarEventEditorState";

export function EditEventName({
    state, setState, OnOKAction,
}: {
    state: ICalendarEventEditorState;
    setState: React.Dispatch<React.SetStateAction<ICalendarEventEditorState>>;
    OnOKAction: (withEventData?: ICalendarEvent) => Promise<void>;
}) {
    return (
        <FormInput
            type="text"
            id="clickTarget_calendarEvent_name"
            label="Name"
            width="84%"
            value={state.calendarEvent.name}
            onChange={(event) => setState({
                ...state,
                calendarEvent: {
                    ...state.calendarEvent,
                    name: event.target.value,
                },
            })}
            onClear={() => setState({
                ...state,
                calendarEvent: {
                    ...state.calendarEvent,
                    name: ``,
                },
            })}
            onEnter={async () => await SaveCalendarEditorStateAndCloseAsync(
                state,
                state.matchingGoals.length === 1
                    ? state.matchingGoals[0].name
                    : state.calendarEvent.name,
                OnOKAction
            )}
            readonly={state.calendarEvent.isRepeating} />
    );
}
